<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  color: white;
  margin: 0;
  width: 100%;
}

.container{
  display: grid;
  grid-template-columns: auto 32px;
  border-bottom: 2px white solid;
  background-color: rgba(255,255,255,0.2);
  align-items: center;
}
.light{
  background-color: inherit;
}

.input{
  grid-column: 1;
}
.icon{
  grid-column: 2;
}

.icon-clear, .icon-check{
  font-size: 29px;
}
.icon-clear{
  color: red;
}
.icon-check{
  color: lightgreen;
}

</style>

<div class="container {theme == 'light' ? 'light' : ''}" style="{style}">
  <div class="input"><input type="text" bind:value="{value}" pattern="{pattern}" on:keyup="{ () => dispatch('changed') }" placeholder="{placeholder}" autocapitalize="none"></div>
  <div class="icon">
    <i class="{ valid ? 'icon-check' : 'icon-clear' }"></i>
  </div>
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let value = "";
export let valid = false;
export let theme = "dark";
export let style = "";
export let placeholder = "";
export let pattern = "";
// [0-9]* for only numbers
// [0-9\-\(\) ]* for phone numbers

</script>